export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img
    src="/logo.png"
    alt="Logo ENOLFC"
    className={`${className} shrink-0 rounded-full object-cover ring-1 ring-white/20`}
    data-testid="logo-mark"
  />
);

export const LogoFull = ({ compact = false }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark className="h-8 w-8" />
    <span className="flex flex-col leading-none">
      <span className="font-display text-2xl font-extrabold uppercase tracking-wide text-white">
        ENOL<span className="text-crimson">FC</span>
      </span>
      {!compact && (
        <span className="font-mono-score text-[9px] uppercase tracking-[0.35em] text-slate-400">
          Fútbol · Sporting
        </span>
      )}
    </span>
  </span>
);

export default LogoFull;
